import { Item, Menu, Separator } from 'react-contexify';
import { FormattedMessage } from 'react-intl';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { makeStyles } from "@mui/styles";
import 'react-contexify/dist/ReactContexify.min.css';

const useStyles = makeStyles(theme => ({
  contextMenu: {
    "& .react-contexify__item__content": {
      alignItems: "center",
      gap: "8px",
    },
  },
  contextItem: {
    "&:hover": {
      "& .react-contexify__item__content": {
        color: "initial !important",
        backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
      },
    },
  },
}));

const ContextMenu = ({
  menuId,
  nodeData,
  onItemClick,
}) => {
  const classes = useStyles();

  const { articleId, topicId, title, type } = nodeData || {};

  const isArticle = (type === "article");
  const isTopic = (type === "topic");

  const handleClick = ({ event, props }) => {
    onItemClick?.({
      event,
      props: Object.assign(
        { ...props, title },
        isArticle && { articleId },
        isTopic && { topicId },
      ),
    });
  };

  const MenuItem = ({ children, data, ...rest }) => (
    <Item className={classes.contextItem} data={{ type, ...data }} onClick={handleClick} {...rest}>
      {children}
    </Item>
  );

  const iconProps = {
    fontSize: "small",
    sx: { mr: 1 },
  };

  return (
    <Menu id={menuId} className={classes.contextMenu}>

      <MenuItem data={{ action: "create", type: "topic" }} disabled={isArticle}>
        <CreateNewFolderIcon {...iconProps} />
        <FormattedMessage id="helpCenter.contextMenu.createTopic" />
      </MenuItem>

      <MenuItem data={{ action: "create", type: "article" }} disabled={isArticle}>
        <DescriptionOutlinedIcon {...iconProps} />
        <FormattedMessage id="helpCenter.contextMenu.createArticle" />
      </MenuItem>

      <Separator />

      {false && (
        <MenuItem data={{ action: "rename" }} disabled>
          <DriveFileRenameOutlineIcon {...iconProps} />
          <FormattedMessage id="helpCenter.contextMenu.rename" />
        </MenuItem>
      )}

      <MenuItem data={{ action: "edit" }}>
        <EditOutlinedIcon {...iconProps} />
        <FormattedMessage id="helpCenter.contextMenu.edit" />
      </MenuItem>

      <Separator />

      <MenuItem data={{ action: "delete" }}>
        <DeleteOutlineIcon {...iconProps} />
        <FormattedMessage id="helpCenter.contextMenu.delete" />
      </MenuItem>

    </Menu>
  );
};

export default ContextMenu;
